import { render, staticRenderFns } from "./MethodSelect.vue?vue&type=template&id=8504a616"
import script from "./MethodSelect.vue?vue&type=script&lang=ts"
export * from "./MethodSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports